import { memo } from 'react'
import { stripeConfigs } from '@constants/stripe'
import cn from 'clsx'
import { AddressElement, PaymentElement } from '@stripe/react-stripe-js'

const AddPaymentCardDialogForm = ({
    stripe,
    elements,
    loading,
    handleSubmit,
    handleModal,
}) => {
    
    return (
        
        /* Important! Specifically using `hidden` here instead of rendering null,
         * because Stripe will fail with very confusing errors otherwise */
        <form
            className={cn({ hidden: loading })}
            onSubmit={handleSubmit}>
            
            {/* <PricingInfo /> */}
            
            {/* {process.env.NODE_ENV !== 'production' && (
                <div className="">
                    <pre><code>4242424242424242</code></pre>
                </div>
            )} */}
            
            <AddressElement options={stripeConfigs.addressElementOpts} />
            
            <PaymentElement options={stripeConfigs.paymentElementOpts} />
            
            <div className="mb-2 modal-footer flex justify-end">
                <button
                    type="button"
                    className="mr-3 btn btn-primary btn-outline"
                    onClick={() => handleModal()}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!stripe || !elements}>
                    Add Payment Method
                </button>
            </div>
        
        </form>
        
    )
    
}

export default memo(AddPaymentCardDialogForm)
